module.exports = __webpack_public_path__ + "img/lipstick_and_perfume_1.c85a7435.png";